// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"partner-link-view_shadow__UzwQQ","partnerLink":"partner-link-view_partnerLink__2kqBL"};